import { ApplicationFormHeader } from 'components';
import { FC } from 'react';
import { IApplicationFormLayoutProps } from './types';

export const ApplicationFormLayout: FC<IApplicationFormLayoutProps> = ({ children }) => {
  const segments = location.pathname.split('/');
  const routeSegment = segments[1]?.toLowerCase();
  const isApplicationEdit = routeSegment === 'application' && segments[2]?.toLowerCase() === 'edit';
  const overflowClass =
    routeSegment === 'application' && !isApplicationEdit
      ? 'overflow-hidden'
      : routeSegment === 'application'
      ? 'overflow-auto'
      : 'overflow-hidden';
  return (
    <div className={`h-full ${overflowClass}`}>
      <ApplicationFormHeader />
      <div className={'w-full h-full'}>
        <div className={'pt-16 h-full'}>{children}</div>
      </div>
    </div>
  );
};
